module.exports = __webpack_public_path__ + "img/lizard.5d08933f.png";